<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
    append-to-body
    fullscreen
  >
    <div class="container txt-black">
      <div class="fs-28 fw-700 text-center txt-pri">Phiếu khám</div>
      <div class="row">
        <div class="col-md-9 vh-90">
          <div class="row">
            <div class="col-md-5">
              <p class="fs-20 fw-700 txt-pri mb-0">{{!personHR ? form && form.patient_name : personHR && personHR.name}}</p>
              <p class="fs-16 txt-neutral-450 fw-400 mb-0"> <span class="mr-3 fw-500">{{!personHR ? (form && form.gender === 1 ? 'Nam' : 'Nữ')  || '' : (personHR && personHR.gender === 1 ? 'Nam' : 'Nữ')  || ''}}</span> {{personHR && getDate(personHR.birthday)}} {{!personHR ? (form && form.career) || '' : (personHR && personHR.career) || ''}}</p>
              <p class="fs-16 fw-400 mb-0 txt-neutral-700">SĐT: {{!personHR ? form && form.phone : personHR && personHR.phone}}</p>
              <p class="fs-16 fw-400 mb-0 txt-neutral-700">Địa chỉ: {{!personHR ? form && form.address : personHR && personHR.address}}</p>
              <p class="fs-16 fw-400 mb-2 txt-neutral-700">
                Người liên hệ: {{(form && form.emergency_contact) || ''}}
                {{form && form.contact_phone ? ', SĐT: ' + form.contact_phone : ''}}
              </p>
            </div>
          </div>
          <div class="mb-2">
            <span class="mr-3 fs-16 fw-700">Thời gian bắt đầu</span>
            <span class="fs-16 fw-400">{{ startTime ? getDateTime(startTime) : 'Chưa bắt đầu' }}</span>
          </div>
          <div class="mb-2">
            <p class="txt-neutral-500  fs-16 fw-500 mb-2">
              Lý do khám bệnh
            </p>
            <p class="fs-16 fw-500 ml-3">{{ consultation && consultation.reason }}</p>
          </div>
          <div class="mb-2">
            <p class="txt-neutral-500 fs-16 fw-500 mb-2">
              Diễn biến
            </p>
            <div
              class="fs-16 fw-500 ml-3"
              v-html="consultation && consultation.progression"
            ></div>
          </div>
          <div class="mb-2">
            <p class="txt-neutral-500  fs-16 fw-500 mb-2">
              Chẩn đoán
            </p>
            <div
              class="fs-16 fw-500 ml-3"
              v-html="consultation && consultation.diagnose"
            ></div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="txt-neutral-500 fs-16 fw-500 mb-2">
                Chỉ định
              </div>
              <div
                class="border border-solid rounded px-3 py-2 h-box"
                v-if="indications && indications.length"
              >
                <div
                  class="underline cursor-pointer"
                  v-for="(indication, index) in indications"
                  :key="index+indication.id"
                  @click="viewIndicationDetail(indication)"
                >
                  {{ indication.name }}
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <span class="txt-neutral-500 fs-16 fw-500">Đơn thuốc</span>
              <div
                class="border border-solid rounded px-3 mt-2 py-2 ml-2 h-box"
                v-if="prescriptions && prescriptions.length"
              >
                <div
                  class="underline cursor-pointer"
                  v-for="(prescription, index) in prescriptions"
                  :key="index+prescription.id"
                  @click="viewDetail(prescription)"
                >
                  {{ prescription.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="mb-2">
            <p class="txt-neutral-500 fs-16 fw-500 mb-2">
              Kết luận
            </p>
            <div
              class="fs-16 fw-500 ml-3"
              v-html="consultation && consultation.prehistoric"
            ></div>
          </div>
          <div class="mb-2">
            <p class="txt-neutral-500 fs-16 fw-500 mb-2">
              <span class="">File đính kèm</span>
            </p>

            <div
              class="mb-2"
              v-if="files && files.length"
            >
              <div
                class="mb-1"
                v-for="(file, index) in files"
                :key="index + 'file'"
              >
                <div class="
                      h-full
                      rounded-xl
                      p-2
                    ">
                  <div class="row">
                    <div
                      class="cursor-pointer text-base row"
                      @click="downloadFile(file.file_name)"
                    >
                      <div class="col-10">
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_24814_125783)">
                              <path
                                d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                                fill="#0263D1"
                              />
                              <path
                                opacity="0.302"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                                fill="white"
                              />
                              <path
                                d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                                fill="white"
                              />
                              <path
                                d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z"
                                fill="white"
                              />
                              <path
                                d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                                fill="white"
                              />
                              <path
                                d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_24814_125783">
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        {{ file.name }}
                      </div>
                      <div class="col-2 flex justify-center items-center">Xem</div>
                    </div>
                    <div class="ml-8 text-sm">
                      <span>{{ file.created_by && file.created_by.name }}</span>
                      <span class="ml-3">{{ formatDMY(file.created_at) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="font-bold text-base my-1 cursor-pointer">
              </div>
              <div v-if="links && links.length">
                <div
                  class="mb-2 row"
                  v-for="(link, index) in links"
                  :key="'link' + index"
                >
                  <div
                    class="cursor-pointer underline text-primary row text-base"
                    @click="openLink(link)"
                  >
                    <div class="col-10">
                      <span>
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.66672 11.9601L5.48672 13.1068C5.1773 13.4162 4.75764 13.5901 4.32005 13.5901C3.88247 13.5901 3.46281 13.4162 3.15339 13.1068C2.84397 12.7974 2.67014 12.3777 2.67014 11.9401C2.67014 11.5026 2.84397 11.0829 3.15339 10.7735L6.18005 7.74014C6.47713 7.4421 6.8774 7.26966 7.29806 7.25849C7.71873 7.24732 8.12758 7.39828 8.44005 7.68014L8.52005 7.74681C8.64647 7.87057 8.81688 7.93905 8.99379 7.93718C9.1707 7.9353 9.33962 7.86323 9.46339 7.73681C9.58716 7.61039 9.65563 7.43998 9.65376 7.26307C9.65188 7.08616 9.57981 6.91724 9.45339 6.79347C9.41576 6.74482 9.37571 6.6981 9.33339 6.65347C8.76429 6.15835 8.02828 5.89804 7.27443 5.92527C6.52059 5.9525 5.80528 6.26524 5.27339 6.80014L2.20672 9.83347C1.68562 10.4007 1.4038 11.1473 1.4201 11.9173C1.43641 12.6874 1.74957 13.4214 2.29421 13.966C2.83884 14.5106 3.57283 14.8238 4.34289 14.8401C5.11294 14.8564 5.85952 14.5746 6.42672 14.0535L7.58005 12.9268C7.69393 12.8026 7.75653 12.6398 7.75526 12.4713C7.75399 12.3028 7.68894 12.141 7.57319 12.0185C7.45745 11.896 7.29961 11.8219 7.13143 11.811C6.96325 11.8002 6.79721 11.8535 6.66672 11.9601ZM13.7934 2.46681C13.2326 1.90948 12.474 1.59666 11.6834 1.59666C10.8927 1.59666 10.1342 1.90948 9.57339 2.46681L8.42005 3.59347C8.30618 3.71771 8.24358 3.88046 8.24485 4.04898C8.24612 4.21751 8.31117 4.3793 8.42691 4.5018C8.54265 4.6243 8.7005 4.69841 8.86868 4.70924C9.03686 4.72006 9.2029 4.66679 9.33339 4.56014L10.4867 3.41347C10.7961 3.10405 11.2158 2.93022 11.6534 2.93022C12.091 2.93022 12.5106 3.10405 12.8201 3.41347C13.1295 3.72289 13.3033 4.14255 13.3033 4.58014C13.3033 5.01772 13.1295 5.43739 12.8201 5.74681L9.79339 8.78014C9.49631 9.07818 9.09604 9.25062 8.67538 9.26179C8.25472 9.27296 7.84586 9.122 7.53339 8.84014L7.45339 8.77347C7.32697 8.6497 7.15656 8.58123 6.97965 8.5831C6.80274 8.58498 6.63382 8.65705 6.51005 8.78347C6.38629 8.90989 6.31781 9.0803 6.31968 9.25721C6.32156 9.43412 6.39363 9.60304 6.52005 9.72681C6.56848 9.77633 6.61967 9.82307 6.67339 9.86681C7.24317 10.3604 7.97887 10.6198 8.73225 10.5926C9.48564 10.5653 10.2007 10.2536 10.7334 9.72014L13.7667 6.68681C14.3276 6.12952 14.6452 5.37296 14.6502 4.5823C14.6552 3.79165 14.3472 3.03113 13.7934 2.46681Z"
                            fill="#6E7883"
                          />
                        </svg>
                      </span>
                      <span class="ml-2 pl-1">{{ link.name }}</span>
                    </div>
                    <div class="col-2 flex justify-center items-center">Xem</div>
                  </div>
                  <div class="
                    ml-9 text-sm
                  ">
                    <span>{{ link.created_by && link.created_by.name }}</span>
                    <span class="ml-3">{{ formatDMY(link.created_at) }}</span>
                  </div>
                </div>
              </div>
              <div
                class="mb-3"
                v-if="formLink"
              >
                <div class="flex justify-between items-center mb-2">
                  <div class="w-20">Tên Link</div>
                  <el-input v-model="formLink.name"></el-input>
                </div>
                <div class="flex justify-between items-center mb-2">
                  <div class="w-20">Đường dẫn</div>
                  <el-input v-model="formLink.url"></el-input>
                </div>
                <div class="flex justify-end space-x-3">
                  <el-button @click="closeAddLink">Hủy</el-button>
                  <el-button
                    type="primary"
                    @click="submitLink"
                  >Lưu Link</el-button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="p-center d-flex justify-content-center align-items-center"
            v-if="loading"
          >
            <span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
            ></span>
          </div>

          <!-- Chỉ định -->
          <ModalIndicationDetail ref="ModalIndicationDetail" />
          <ModalCreateIndicationOrder
            ref="ModalCreateIndicationOrder"
            :consultation_id="(consultation && consultation.id) || null"
            @refresh="refresh"
          />

          <!-- Thuốc -->
          <ModalAddHR
            ref="ModalAddHR"
            :person_id="personHR.id"
            :consultation_id="consultation && consultation.id"
            @refresh="refresh"
          />

          <ModalViewHR
            :person="personHR"
            ref="ModalViewHR"
          />

          <!-- Upload file -->
          <input
            type="file"
            @change="onSelectedFile($event)"
            class="d-none"
            ref="inputFile"
            multiple
          />
          <div
            class="modal fade"
            id="modalUploadResultConsu"
            tabindex="-1"
            aria-labelledby="modalUploadTitle"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-sm modal-dialog-centered">
              <div class="modal-content shadow-lg">
                <div class="modal-header border-0 bg-white mb-0">
                  <h5 class="ml-4 fs-18 fw-700 txt-black">Chọn tệp</h5>
                  <img
                    src="../../../../public/assets/images/icon/close-gray.svg"
                    height="25px"
                    class="cursor-pointer mr-3 mb-2"
                    data-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div class="modal-body">
                  <div
                    class="upload-btn mb-3"
                    @click="uploadDocs"
                  >
                    <img
                      class="mr-1"
                      src="../../../../public/assets/images/icon/u_upload.svg"
                    />
                    <span class="fs-14 txt-pri">Chọn file</span>
                  </div>
                  <div
                    class="mb-3"
                    v-for="(doc, i) in nameFiles"
                    :key="i + 'slt_file'"
                  >
                    <div class="d-flex w-100 justify-content-between align-items-center">
                      <el-input
                        v-model="doc.description"
                        class="fs-14 fw-600 mb-0 max-line-1 w-265px"
                      />
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="cursor-pointer"
                        @click="deleteSltDoct(i)"
                      >
                        <path
                          d="M6.00012 18.4998L17.9999 6.5"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.9999 18.4998L6.00012 6.5"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
                    @click="onUpload"
                    :disabled="!selected_docs || !selected_docs.length"
                  >
                    Tải lên
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <TemplatePhieuKhamBenhView
            v-if="form && !loading && dialogVisible"
            ref="TemplatePhieuKhamBenhView"
            :form="form"
            :user="personHR"
            @close="close"
            :consultation="consultation"
            :update_id="consultation && consultation.id"
            @saveFile="saveFileComplete"
            @startTime="startTime = $event"
            @refresh="refresh"
          ></TemplatePhieuKhamBenhView>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
  
  <script>
import ModalCreateIndicationOrder from '../../../components/Indications/ModalCreateIndicationOrder.vue'
import uploadConsultationFile from '../../../utils/uploadConsultationFile'
import ModalIndicationDetail from '../Indication/ModalDetail.vue'
import TemplatePhieuKhamBenhView from './TemplateView.vue'
import ModalAddHR from '../../HealthRecordMed/ModalAdd.vue'
import ModalViewHR from '../../HealthRecordMed/ModalView.vue'
import { mapState } from 'vuex'

export default {
  name: 'ViewPhieuKhamBenh',
  components: { TemplatePhieuKhamBenhView, ModalCreateIndicationOrder, ModalIndicationDetail, ModalAddHR, ModalViewHR },
  props: ['appt'],
  data () {
    return {
      check: true,
      clinic: null,
      loading: false,
      dialogVisible: false,
      form: {
        progression: '',
        diagnose: '',
        indication: '',
        reason: '',
        prehistoric: '',
        patient_name: '',
        birthday: '',
        career: '',
        gender: '',
        address: '',
        phone: '',
        emergency_contact: '',
        contact_phone: '',
        start_time: null,
        city: '',
        appt_id: null,
        notes: '',
        consultation: null
      },
      consultation: null,
      startTime: null,
      indications: [],
      prescriptions: [],
      uploadConsultationFile,
      selected_docs: [],
      nameFiles: [],
      links: [],
      files: [],
      formLink: null
    }
  },
  computed: {
    ...mapState({
      personHR: state => state.personHR
    })
  },
  watch: {
    '$refresh' () {
      if (this.consultation?.id) {
        this.getConsultationByIDV2()
        this.selected_docs = []
        this.nameFiles = []
      }
    }
  },
  mounted () {
    this.$bus.on('ViewKhamBenh:refresh', () => {
      this.getConsultationByIDV2()
    })
  },
  destroyed () {
    this.$bus.off('ViewKhamBenh:refresh')
  },
  methods: {
    close () {
      this.dialogVisible = false
    },
    refresh () {
      this.$emit('refresh')
      this.getConsultationByIDV2()
    },
    openDialogView (obj) {
      if (obj) {
        this.dialogVisible = true
        this.consultation = obj
        this.getConsultationByIDV2()
      }
    },
    async createConsultation () {
      try {
        const self = this
        const form = {
          health_record_id: this.appt?.health_record_id ? this.appt?.health_record_id : this.$route.params.id ? this.$route.params.id : this.$route.query.id,
          appt_id: this.appt ? this.appt.id : null
        }
        if (!form.appt_id) delete form.appt_id
        await this.$rf
          .getRequest('DoctorRequest')
          .createConsultation(form)
          .then((res) => {
            self.consultation = res.data
            this.$emit('refresh')
          })
      } catch (error) {
        console.log('createConsultation', error)
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.startTime = null
      this.indications = []
      this.prescriptions = []
      this.consultation = null
      this.links = []
      this.files = []
      this.selected_docs = []
      this.nameFiles = []
      this.form = {
        progression: '',
        diagnose: '',
        indication: '',
        reason: '',
        prehistoric: '',
        patient_name: '',
        birthday: '',
        career: '',
        gender: '',
        address: '',
        phone: '',
        emergency_contact: '',
        contact_phone: '',
        start_time: null,
        city: '',
        appt_id: null,
        notes: '',
        consultation: null
      }
    },
    deleteSltDoct (i) {
      this.selected_docs.splice(i, 1)
      this.nameFiles.splice(i, 1)
    },
    showModalPrint (show) {
      window.$('#modal__print').modal(show ? 'show' : 'hide')
    },
    getGender (gender = 1) {
      return gender === 1 ? 'Nam' : gender === 2 ? 'Nữ' : gender === 3 ? 'Khác' : ''
    },
    getAges (date) {
      let bd = window.moment(date)
      let age = window.moment().diff(bd, 'years')
      return bd.format('DD/MM/YYYY') + ' (' + age + ' tuổi)'
    },
    getDate (date) {
      return date && window.moment(date).format('DD/MM/YYYY')
    },
    getTime (date) {
      return date && window.moment(date).format('HH:mm')
    },
    getDateTime (date_time) {
      return date_time && window.moment(date_time).format('HH:mm:ss DD/MM/YYYY')
    },
    saveFileComplete (data) {
      this.$emit('saveFileComplete', data)
    },
    openCreateIndication () {
      this.$refs.ModalCreateIndicationOrder.openDialog('create')
    },
    async getConsultationByIDV2 () {
      try {
        const self = this
        await this.$rf
          .getRequest('DoctorRequest')
          .getConsultationByIDV2(this.consultation?.id)
          .then((res) => {
            self.indications = []
            self.consultation = res.data
            self.consultation && self.consultation.indication_orders && self.consultation.indication_orders.forEach(item => {
              self.indications = [...self.indications, ...item.indications]
            })
            self.prescriptions = self.consultation && self.consultation.prescriptions

            self.files = []
            self.links = []
            // eslint-disable-next-line no-unused-expressions
            self.consultation?.consultation_files?.map(item => {
              if (item.type === 1) self.files.push(item)
              if (item.type === 2) self.links.push(item)
              return undefined
            })
          })
      } catch (error) {
        console.log('createConsultation', error)
      }
    },
    viewIndicationDetail (row) {
      this.$refs.ModalIndicationDetail.openDialog(row.id)
    },
    createPrescription () {
      this.$refs.ModalAddHR.openDialog()
    },
    async onSubmitFiles (docs) {
      uploadConsultationFile.consultationUploadHanlder(this.consultation.id, docs, 1, null, this.nameFiles)
    },
    onUpload () {
      if (!this.selected_docs || !this.selected_docs.length) {
        alert('Vui lòng chọn tài liệu')
        return
      }
      this.onSubmitFiles(this.selected_docs)
      this.$refs.inputFile.value = null
      this.modalUploadResultConsu(false)
    },
    modalUploadResultConsu (show) {
      window.$('#modalUploadResultConsu').modal(show ? 'show' : 'hide')
    },
    uploadDocs () {
      this.$refs.inputFile.click()
      this.$refs.inputFile.value = null
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        for (let i = 0; i < files.length; i++) {
          this.nameFiles.push({
            description: files[i].name
          })
          this.selected_docs.push(files[i])
          console.log('this.nameFiles[i]', this.nameFiles[i])
        }
      }
    },
    async downloadFile (name) {
      if (!name) return
      const self = this
      const params = {
        fileName: name
      }
      const header = {
        'x-api-key': '4be5160e89e681cede9a80ae6db6af7c'
      }
      await self.$rf.getRequest('AuthRequest').getLinkDownloadAwsRc(params, header, false).then((r) => {
        if (r?.data?.data) window.open(r.data.data)
      }).catch((e) => {
        self.$toast.open({
          message: 'File không tồn tại hoặc gặp lỗi trong quá trình tải xuống',
          type: 'warning'
        })
        console.error(e)
      })
    },
    formatDMY (date) {
      return date && window.moment(date).format('HH:mm DD-MM-YYYY')
    },
    addLink () {
      this.formLink = {
        name: '',
        url: '',
        type: 2
      }
    },
    openLink (link) {
      link.url && window.open(link.url)
    },
    closeAddLink () {
      this.formLink = null
    },
    submitLink () {
      if (!this.formLink.name || !this.formLink.url) {
        alert('Vui lòng nhập đủ thông tin')
        return
      }
      this.createLink(this.formLink)
    },
    async createLink (options) {
      const params = {
        ...options,
        consultation_id: this.consultation.id
      }
      await this.$rf.getRequest('DoctorRequest').createConsultationAttach(params).then((r) => {
        this.getConsultationByIDV2()
        this.closeAddLink()
        return r.data
      }).catch((error) => {
        console.log('error', error)
      })
    },
    viewDetail (obj) {
      this.$refs.ModalViewHR.openDialog(obj.id)
    }
  }
}
      </script>
      <style lang="scss" scoped>
::v-deep {
  .required:after {
    content: " *";
    color: red;
  }
  .upload-btn {
    width: 100%;
    border: 1px dashed #20419b;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    border-radius: 9px;
    cursor: pointer;
  }
  .upload-btn2 {
    padding: 18px 0px 18px 0px;
  }
  .w-265px {
    width: 100%;
    max-width: 265px;
  }
  .h-box {
    height: calc(100% - 25px);
  }
  .vh-90 {
    overflow: auto;
    height: 90vh;
    overflow-x: hidden;
    border-right: 1px solid rgb(209, 209, 209);
  }
}
</style>
      